import { useState, useCallback } from 'react'

export const usePillarNavigation = (topics) => {
  const [activeTopic, setActiveTopic] = useState(null)

  const idOfActiveTopic = activeTopic?.id
  const idOfFirstTopic = topics[0]?.id
  const idOfLastTopic = topics[topics.length - 1]?.id

  const hasNextTopic = idOfActiveTopic !== idOfLastTopic
  const hasPreviousTopic = idOfActiveTopic !== idOfFirstTopic

  const nextTopic = hasNextTopic
    ? topics.find((topic) => topic.id === idOfActiveTopic + 1)
    : undefined
  const previousTopic = hasPreviousTopic
    ? topics.find((topic) => topic.id === idOfActiveTopic - 1)
    : undefined

  const handleGoToPreviousTopic = useCallback(
    (callback) => () => {
      if (hasPreviousTopic) {
        setActiveTopic(previousTopic)
      }
      callback?.()
    },
    [hasPreviousTopic, previousTopic]
  )

  const handleGoToNextTopic = useCallback(
    (callback) => () => {
      if (hasNextTopic) {
        setActiveTopic(nextTopic)
      }
      callback?.()
    },
    [hasNextTopic, nextTopic]
  )

  return {
    activeTopic,
    setActiveTopic,
    hasNextTopic,
    hasPreviousTopic,
    nextTopic,
    previousTopic,
    handleGoToPreviousTopic,
    handleGoToNextTopic
  }
}
